export default "__VITE_ASSET__9CeZZ_xh__"